// ============================================================================
// OBT F3 — Tek soru-cevap salt-okunur görünümü (inceleyen için)
// ============================================================================
// Backend `ReviewAnswerOut` biçimini gösterir. Boolean false ANLAMLIDIR
// (gizlenmez). Eksik/boş cevap açıkça işaretlenir. Ham veri/id gösterilmez.
// ============================================================================

import { CheckCircle2, XCircle, MinusCircle } from 'lucide-react';

function isBlank(answer) {
  return (
    answer.answer_boolean == null &&
    (answer.answer_text == null || answer.answer_text === '') &&
    (!Array.isArray(answer.option_values) || answer.option_values.length === 0)
  );
}

function BooleanValue({ value }) {
  if (value === true) {
    return (
      <span className="inline-flex items-center gap-1.5 text-sm font-medium text-green-700">
        <CheckCircle2 className="h-4 w-4" aria-hidden="true" /> Evet
      </span>
    );
  }
  if (value === false) {
    return (
      <span className="inline-flex items-center gap-1.5 text-sm font-medium text-red-700">
        <XCircle className="h-4 w-4" aria-hidden="true" /> Hayır
      </span>
    );
  }
  return <BlankValue />;
}

function BlankValue() {
  return (
    <span className="inline-flex items-center gap-1.5 text-sm italic text-gray-400">
      <MinusCircle className="h-4 w-4" aria-hidden="true" /> Cevaplanmadı
    </span>
  );
}

/**
 * @param {object} props
 * @param {import('./reviewApi').ReviewAnswerOut} props.answer
 * @param {number} props.index
 */
export default function AnswerReviewField({ answer, index }) {
  const type = answer?.question_type;
  const blank = isBlank(answer);

  return (
    <div className="rounded-lg border border-gray-200 p-3">
      <div className="mb-1.5 flex items-start gap-2">
        <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded bg-gray-100 text-xs font-semibold text-gray-600">
          {index + 1}
        </span>
        <p className="text-sm font-medium text-gray-900">
          {answer?.question_text || 'Soru'}
        </p>
      </div>
      <div className="pl-7">
        {blank && <BlankValue />}
        {!blank && type === 'boolean' && <BooleanValue value={answer.answer_boolean} />}
        {!blank && (type === 'single_select' || type === 'multi_select') && (
          <div className="flex flex-wrap gap-1.5">
            {answer.option_values.map((v) => (
              <span
                key={v}
                className="inline-flex items-center rounded-full bg-blue-50 px-2.5 py-0.5 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-200"
              >
                {v}
              </span>
            ))}
          </div>
        )}
        {!blank && (type === 'text' || type === 'document') && (
          <p className="whitespace-pre-wrap break-words text-sm text-gray-700">
            {answer.answer_text || <BlankValue />}
          </p>
        )}
        {!blank &&
          type !== 'boolean' &&
          type !== 'single_select' &&
          type !== 'multi_select' &&
          type !== 'text' &&
          type !== 'document' && (
            <p className="whitespace-pre-wrap break-words text-sm text-gray-700">
              {answer.answer_text || '—'}
            </p>
          )}
      </div>
    </div>
  );
}
